import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { Box, List, ListItemButton, Stack, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Item,
  ScrollableTabs,
  TabTextVariant,
  WsButton,
  WsColors,
  WsElementWithPopOver,
  WsIconAssignCandidate,
  WsIconText,
  WsTitleBanner,
  WsTypoVariants,
} from 'wisestep-base';

import { useWorkspaceContext } from '../../context';
import { ClosureAction, useClosureAuthz } from '../../hooks/useClosureAuthz';

import ClosureDataTable from './components/ClosureDataTable';
import ContractPlacementDataTable from './components/ContractPlacementDataTable';

const StyledStack = styled(Stack)({
  backgroundColor: WsColors.TheBlues50,
  gap: 1,
});

interface IScrollableTab {
  tabName: string;
}

const ClosureListing = () => {
  const navigate = useNavigate();
  const navigateToAddClosure = (placementType: string) =>
    navigate('/placements/createoptions', { state: { placementType: placementType } });
  const isAuthorizedAddClosure = useClosureAuthz(ClosureAction.ADD_CLOSURE_ADDITION);
  const [tabList, setTabList] = useState<IScrollableTab[]>([]);
  const [tabPanelPage, setTabPanelPage] = useState<number>(0);
  const workspace = useWorkspaceContext();
  const closureListingAccess = useClosureAuthz(ClosureAction.VIEW_CLOSURE_LISTING_PAGE);
  useEffect(() => {
    const setTabListByPermission = () => {
      const tabs: IScrollableTab[] = [];
      tabs.push({ tabName: 'Permanent Placements' });
      setTabList(tabs);
    };
    setTabListByPermission();
  }, []);

  const AddPlacementButton = () => (
    <WsElementWithPopOver
      element={
        <WsButton variant="contained" size="medium" endIcon={<KeyboardArrowDownOutlinedIcon />}>
          Add Placement
        </WsButton>
      }
    >
      <List dense={true} sx={{ pl: 1 }}>
        <ListItemButton onClick={() => navigateToAddClosure('PERMANENT')}>
          <WsIconText
            text="Permanent Placement"
            icon={<WsIconAssignCandidate />}
            textCursor="pointer"
            textSize={WsTypoVariants.BODY1}
          />
        </ListItemButton>
      </List>
    </WsElementWithPopOver>
  );

  return (
    <Box borderRadius={1.5}>
      {(workspace.owns || closureListingAccess) && (
        <StyledStack justifyContent="space-between">
          <Box>
            <WsTitleBanner
              title={tabPanelPage === 0 ? 'Placement List' : 'Contract Placement List'}
              backButton={false}
              showBetaIcon={true}
            />
          </Box>
          {(workspace.owns || isAuthorizedAddClosure) && (
            <Item sx={{ display: 'flex', justifyContent: 'right' }}>
              <AddPlacementButton />
            </Item>
          )}
          <ScrollableTabs
            variant={TabTextVariant.SUB_TITLE}
            scrollList={tabList}
            getTabIndex={(index: number) => {
              setTabPanelPage(index);
            }}
            defaultValue={tabPanelPage}
          />
          {tabPanelPage === 0 && <ClosureDataTable />}
          {tabPanelPage === 1 && <ContractPlacementDataTable />}
        </StyledStack>
      )}
    </Box>
  );
};

export default ClosureListing;
